import settings from '@config/site.yml?path=site.{rails_env}.public';

export const IMAGE_URL = settings.cdnUrl
export const SOCKET_URL = settings.socketUrl
export const SOCKET_STATION = settings.stationId;
export const API_URL = `${settings.apiUrl}/${settings.apiVersion}`;
export const PROGRAMS_URL = '/programmas';

export const onProgramChange = (cb, station) => {
  const sock = window.Q.connect(station || SOCKET_STATION, SOCKET_URL);
  const programSub = sock.subscribe('program');
  programSub.on('change', cb, { backlog: 1 });
  return programSub;
};

